import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./emailTemplate.module.scss";
import FormikControl from "../../../components/formComponents/FormikControl";
import { Form, Formik } from "formik";
import i18next from "i18next";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import FooterButtonSection from "../../../components/footerSection/FooterButtonSection";
import {
  getDropDownValue,
  generalValidationMessage,
} from "../../../config/appConfig";
import * as Yup from "yup";
import PreviewBox from "./PreviewBox";
import CustomModalDialog from "../../../components/modal/CustomModalDialog";
import {
  getTemplateSectionbyId,
  previewCertificateChange,
  saveCertifciateMail,
} from "../../../services/APIService";
import _ from "lodash";
import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const EmailTemplate = (props) => {
  const { setOpenSnackbar } = props;
  const [pdfUrl, setPdfUrl] = useState("");
  const templateList = [
    {
      key: "100% onderhouden",
      value: 1,
    },
    {
      key: "BOVAG Onderhoudsvrij",
      value: 2,
    },
    {
      key: "BOVAG Import Tellercheck",
      value: 3,
    },
    {
      key: "BOVAG-Garantie",
      value: 4,
    },
    {
      key: "Keurmerk5",
      value: 5,
    },
    {
      key: "Gecombineerd",
      value: 6,
    },
  ];

  const [templateId, setTemplateId] = useState(templateList[0]);

  const setDropdownValue = (value, dropdownOptions, name, formikProps) => {
    let selectedOption = getDropDownValue(value, dropdownOptions);

    formikProps.setFieldValue(name, selectedOption);
    formikProps.setFieldTouched(name, false);
  };
  const modules = {
    toolbar: [["bold", "italic", "underline"], [{ list: "bullet" }], ["link"]],
    clipboard: {
      matchVisual: false,
    },
  };
  const formats = ["bold", "italic", "underline", "list", "link"];

  const defaultValues = {
    template: templateList[0],
    block1: "",
    block2: "",
    isSendEmails: ""
  };

  const [initalValue, setInitalValue] = useState(defaultValues);
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  const validationSchema = Yup.object().shape({
    template: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
  });

  const [preview, setPreview] = useState(false);
  const [buttonName, setButtonName] = useState("");
  const { setApiErrorModalState } = useApiErrorModalContext();

  const handleSave = (values) => {
    let payload = {
      certificate_Id: _.get(values, "template.value", ""),
      isSendEmails:  _.get(values, "isSendEmails", false),
      isEmailTemplate: true,
      section1: _.get(values, "block1", ""),
      section2: _.get(values, "block2", ""),
    };
    saveCertifciateMail(payload)
      .then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true) === false) {
          _.set(response, "status", 200);
          setApiErrorModalState({
            error: response,
          });
        } else {
          setOpenSnackbar(true);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const handlePreview = (values) => {
    setPdfUrl("");
    let payload = {
      certificateId: _.get(values, "template.value", ""),
      section1: _.get(values, "block1", ""),
      section2: _.get(values, "block2", ""),
    };
    previewCertificateChange(payload)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setPdfUrl(response.pdfUrl);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const handleSubmit = (values) => {
    if (buttonName === "save") {
      handleSave(values);
    } else if (buttonName === "preview") {
      handlePreview(values);
      setPreview(true);
    } else {
      setButtonName("");
    }
  };

  useEffect(() => {
    getTemplateSectionbyId({ CertificateId: templateId?.value, isEmailBlock: true })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setInitalValue({
            template: null,
            isSendEmails: false,
            block1: "",
            block2: "",
          });
          setApiErrorModalState({ error: response });
        } else {
          setInitalValue({
            template: templateId,
            block1: response?.section1,
            block2: response?.section2,
            isSendEmails: _.get(response, 'emailStatus', false),
          });
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId]);
  return (
    <>
      <Box className={styles.emailTextWrapper} data-testid="EmailTemplate">
        {i18next.t("Email Templates")}
      </Box>
      <Box className={styles.emailWrapper}>
        <Formik
          enableReinitialize={true}
          initialValues={initalValue}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <Form onSubmit={formikProps.handleSubmit}>
              <Box className={styles.insideEmailWrapper}>
                <Box className="textboxDoubleWraper">
                  <Box className={styles.blockWrapper1}>
                    <label className={styles.labelText}>
                      {i18next.t("Select template")}
                    </label>
                    <FormikControl
                      variant="filled"
                      control="autocomplete"
                      label=""
                      options={templateList}
                      hiddenLabel
                      id="template"
                      name="template"
                      size="small"
                      isSelect={true}
                      disabled={false}
                      getOptionDisabled={false}
                      placeholder={i18next.t("Select one")}
                      className="input-grp__box select"
                      freeSolo={false}
                      onChange={(e, value) => {
                        setDropdownValue(
                          value,
                          templateList,
                          "template",
                          formikProps
                        );
                        setInitalValue({
                          template: value,
                          isSendEmails: false,
                          block1: "",
                          block2: "",
                        });
                        setTemplateId(value);
                      }}
                      value={formikProps?.values.template}
                      hasError={
                        !!(
                          formikProps?.touched.template &&
                          formikProps?.errors.template
                        )
                      }
                      error={
                        !!(
                          formikProps?.touched.template &&
                          formikProps?.errors.template
                        )
                      }
                      errorMessage={formikProps?.errors?.template}
                    />
                  </Box>
                  <Box className={styles.switchButton}>
                    <FormikControl
                      variant="filled"
                      control="switch"
                      label="Send Emails"
                      id="isSendEmails"
                      name="isSendEmails"
                      isHideLabel={true}
                      checked={formikProps?.values.isSendEmails}
                      className="input-grp__box select"
                      onChange={(e) => {
                        formikProps.setFieldValue("isSendEmails", e.target.checked);
                      }}
                      value={formikProps?.values.isSendEmails}
                      hasError={
                        !!(
                          formikProps?.touched.isSendEmails &&
                          formikProps?.errors.isSendEmails
                        )
                      }
                      error={
                        !!(
                          formikProps?.touched.isSendEmails &&
                          formikProps?.errors.isSendEmails
                        )
                      }
                      errorMessage={formikProps?.errors?.isSendEmails}
                    />
                  </Box>
                </Box>


                <Box className={styles.blockWrapper1}>
                  <label className={styles.labelText}>
                    {i18next.t("Block 1")}
                  </label>
                  <ReactQuill
                    theme="snow"
                    id="block1"
                    className={styles.blockTextBox}
                    value={formikProps.values.block1}
                    onChange={(e) => formikProps.setFieldValue("block1", e)}
                    modules={modules}
                    formats={formats}
                  />
                </Box>

                <Box className={styles.wrapper}>
                  <Box className={styles.blockWrapper1}>
                    <label className={styles.labelText}>
                      {i18next.t("Block 2")}
                    </label>
                    <ReactQuill
                      theme="snow"
                      className={styles.blockTextBox}
                      value={formikProps.values.block2}
                      onChange={(e) => formikProps.setFieldValue("block2", e)}
                      modules={modules}
                      formats={formats}
                    />
                  </Box>
                  <Box className={styles.buttonWrapper}>
                    <FooterButtonSection
                      footerStyle={styles.buttonWrapper}
                      btnlist={[
                        {
                          title: "Preview",
                          iconStyle: "",
                          buttonType:
                            "muibtn-secondary-with-border-without-icon",
                          attriType: "button",
                          withIcon: false,
                          showCountSection: false,
                          count: 0,
                          handleClick: () => {
                            setButtonName("preview");
                            formikProps.handleSubmit();
                          },
                          isDisabled: false,
                        },
                        {
                          title: "Save",
                          iconStyle: "",
                          buttonType: "muibtn-primary",
                          attriType: "button",
                          withIcon: false,
                          showCountSection: false,
                          count: 0,
                          handleClick: () => {
                            setButtonName("save");
                            formikProps.handleSubmit();
                          },
                          isDisabled:
                            !(formikProps.values.block1 !==
                              defaultValues.block1 ||
                              formikProps.values.block2 !== defaultValues.block2),
                        },
                      ]}
                    />
                  </Box>
                </Box>
              </Box>
              {!_.isEmpty(pdfUrl) ? (
                <CustomModalDialog
                  title={formikProps.values.template?.key}
                  isShow={preview}
                  onClose={() => setPreview(false)}
                  className={"settingEmail"}
                  isCloseButton={true}
                  hasFooter={false}
                >
                  <PreviewBox pdfUrl={pdfUrl} />
                </CustomModalDialog>
              ) : null}
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default EmailTemplate;
EmailTemplate.propTypes = {
  setOpenSnackbar: PropTypes.any
}